import { GridItemType } from "components/Chakra/Card/CardMotion";
import CardVariant from "components/Chakra/Card/CardVariant";

export const secondTabItems: Array<GridItemType> = [
  {
    content: (
      <CardVariant
        type="GREY_DARK"
        title="Kompletní prověření v 16 CZ i SK rejstřících"
        subTitle="Prověření rizikovosti osob"
        to="/provereni-rizikovosti-osob"
        image={{
          src: "/img/scenes/NewHomepage/reportProvereneOsoby.webp",
          style: {
            position: "relative",
            bottom: "-40px",
            objectFit: "cover",
            marginTop: "auto",
            maxWidth: "80%",
          },
        }}
        trackingElab="CC_makléř"
      />
    ),
    gridItemSetting: { name: "A", h: { base: "360px", md: "500px" } },
  },
  {
    content: (
      <CardVariant
        type="ORANGE"
        title="Inzeruje s námi přes 500 realitních kanceláří"
        subTitle="Přehledná inzerce"
        to="/pro-realitni-kancelare"
        image={{
          src: "/img/scenes/NewHomepage/loga-realitek.webp",
          style: {
            position: "relative",
            bottom: "24px",
            left: "0",
            objectFit: "cover",
            marginTop: "auto",
            maxWidth: "80%",
          },
          // width: "400px",
        }}
        bottomText="a další"
        trackingElab="Realitní inzerce"
      />
    ),
    gridItemSetting: { name: "B", h: { base: "360px", md: "500px" } },
  },
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_DARK_GRAY"
        title="Správa pronájmu ve vlastních rukou"
        subTitle="Aplikace Houmy"
        bgImage={{
          scr: "/img/scenes/NewHomepage/product-tile-houmy.png",
          filter: "none",
        }}
        href="https://www.houmy.cz/"
        trackingElab="Aplikace Houmy RK"
      />
    ),
    gridItemSetting: { name: "C", h: { base: "360px", md: "500px" } },
  },
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_WHITE"
        title="Výhodnější balíčky prověření pro vás  a kolegy"
        subTitle="Balíčky prověření"
        bgImage={{
          scr: "/img/scenes/NewHomepage/woman-office.webp",
          objectFit: "top",
        }}
        to="/balicky-provereni"
        trackingElab="Aplikace Houmy RK"
      />
    ),
    gridItemSetting: { name: "D", h: { base: "300px", md: "240px" } },
  },
  {
    content: (
      <CardVariant
        type="IMAGE_BACKGROUND_WHITE"
        title="Průvodce světem realit"
        subTitle="Realitní blog"
        bgImage={{
          scr: "/img/scenes/NewHomepage/notebook-bed.webp",
          objectFit: "20% 60%",
        }}
        to="/radce/majitel"
        trackingElab="Realitní blog_makléř"
      />
    ),
    gridItemSetting: { name: "E", h: { base: "300px", md: "240px" } },
  },
  {
    content: (
      <CardVariant
        title="Inzerát v nejlepším světle"
        subTitle="Vizuální prezentace"
        type="GREY_DARK"
        to="/vizualni-prezentace"
        trackingElab="Vizuální prezentace_makléř"
      />
    ),
    gridItemSetting: { name: "F", h: { base: "300px", md: "240px" } },
  },
];
